import { render } from "./ApresentarGrupoCampos.vue?vue&type=template&id=5045912c&scoped=true&ts=true"
import script from "./ApresentarGrupoCampos.vue?vue&type=script&lang=ts"
export * from "./ApresentarGrupoCampos.vue?vue&type=script&lang=ts"

import "./ApresentarGrupoCampos.vue?vue&type=style&index=0&id=5045912c&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5045912c"]])

export default __exports__